module.exports = __webpack_public_path__ + "static/media/tiffany_feng.0ecc610d.png";